import * as Spring from "react-spring";

export function searchResults(searching: boolean) {
	return Spring.useSpring({
		from: { opacity: 0 },
		to: { opacity: searching ? 1 : 0 }
	});
}
